/*
 * コンサルタント ファイル共有メッセージの作成
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_CREATE_PRO_RFP_SHARE_DOCUMENT_MESSAGE_LOG = 'API_CREATE_PRO_RFP_SHARE_DOCUMENT_MESSAGE_LOG';
/** コンサルタント 案件条件相談：メッセージ閲覧ログ作成 */
export const apiCreateProfessionalRfpMessageLog = ({ path: { id, shareDocumentMessageId } }, meta) => apiUpdate(API_CREATE_PRO_RFP_SHARE_DOCUMENT_MESSAGE_LOG, `/professional/rfp/${id}/share_document_message_log/${shareDocumentMessageId}`, {}, Object.assign(Object.assign({}, meta), { id }));
